import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/Home/HomePage";
//import McqsListPage from "../pages/MCQs/McqsListPage";
import BlogPost from "../pages/BlogPost/BlogPost";
import McqsPost from "../pages/McqsPost/McqsPost";
import AllBogs from "../pages/AllBlogs/AllBlogs";
import OnlineTestSeries from "../pages/OnlineTestSeries/OnlineTestSeries";
import OnlineTestSeriesLandingPage from "../pages/OnlineTestSeries/OnlineTestSeriesLandingPage";
import TestSeries from "../pages/TestSeries/TestSeries";
import TestInstructions from "../pages/OnlineTests/TestInstructions";
import TestPage from "../pages/OnlineTests/TestPage";
import LoginPage from "../pages/LoginPage/LoginPage";
import Dashboard from "../pages/Dashboard/Dashboard";
import TestResult from "../pages/OnlineTests/TestResult/TestResult";
import TestSolutions from "../pages/OnlineTests/TestSolutions/TestSolutions";
import ContactUs from "../pages/ContactUs/ContactUs";
import AboutUs from "../pages/AboutUs/AboutUs";
import TermsAndConditions from "../pages/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import SiteMaps from "../pages/SiteMaps/SiteMaps";
import Disclaimer from "../pages/Disclaimer/Disclaimer";
import SearchResults from "../pages/SearchResults/SearchResults";
import Profile from "../pages/Profile/Profile";
import Register from "../pages/Register/Register";
import MyTests from "../pages/MyTests/MyTests";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import Checkout from "../pages/Payments/Checkout/Checkout";
import Success from "../pages/Payments/Success/Success";
import Failure from "../pages/Payments/Failure/Failure";
import CoursesPage from "../pages/Courses/CoursesPage";
import CourseDetail from "../pages/Courses/CourseDetails";
import LessonPlayer from "../pages/Courses/LessonPlayer";
import LiveClassesPage from "../pages/Courses/LiveClasses/LiveClassesPage";
import LiveClassDetail from "../pages/Courses/LiveClasses/LiveClassDetails";
import LiveClassRoom from "../pages/Courses/LiveClasses/LiveClassRoom";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import PublicRoute from "./PublicRoutes";
import PrivateRoute from "./PrivateRoutes";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* <Route path="/mcqs" element={<McqsListPage />} /> */}
      <Route path="/blogs/blog-post/:category/:subCategory/:slug" element={<BlogPost />} />
      <Route path="/mcqs/mcqs-post/:category/:subCategory/:slug" element={<McqsPost />} />
      {/* <Route path="/online-tests/:category/:slug" element={<TestSeries />} /> */}
      <Route path="/online-test-series" element={<OnlineTestSeries />} />
      <Route path="/online-test-series/:testwise/:category" element={<OnlineTestSeriesLandingPage />} />
      <Route path="/online-test-series/:testwise/:category/:slug" element={<TestSeries />} />
      <Route path="/blogs/all-blogs/:category" element={<AllBogs />} />
      <Route path="/online-tests/instructions/:slug/:id" element={<TestInstructions />} />
      <Route path="/online-tests/test-page/:slug/:id" element={<TestPage />} />
      <Route path="/online-tests/test-result/:slug/:test_id" element={<TestResult />} />
      <Route path="/online-tests/test-solutions/:slug/:test_id" element={<TestSolutions />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/site-maps" element={<SiteMaps />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/search" element={<SearchResults />} />
      <Route path="/courses" element={<CoursesPage />} />
      <Route path="/courses/:courseId" element={<CourseDetail />} />
      <Route path="/live-classes" element={<LiveClassesPage />} />
      <Route path="/live-classes/:course_slug"     element={<LiveClassDetail />} />
      {/* ══════════════════════════════════════
          PUBLIC ONLY — redirect to /dashboard if already logged in
      ══════════════════════════════════════ */}
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
      <Route path="/forgot-password"      element={<PublicRoute><ForgotPassword /></PublicRoute>} />
      <Route path="/reset-password/:token" element={<PublicRoute><ResetPassword /></PublicRoute>} />
      {/* ══════════════════════════════════════
          PRIVATE — must be logged in
      ══════════════════════════════════════ */}
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
      <Route path="/checkout" element={<PrivateRoute><Checkout /></PrivateRoute>} />
      <Route path="/checkout/success" element={<PrivateRoute><Success /></PrivateRoute>} />
      <Route path="/checkout/failure" element={<PrivateRoute><Failure /></PrivateRoute>} />
      <Route path="/tests" element={<PrivateRoute><MyTests /></PrivateRoute>} />
      <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
      <Route path="/live-classes/:course_slug/:classId/join" element={<PrivateRoute><LiveClassRoom /></PrivateRoute>} />
      <Route path="/courses/:courseId/learn" element={<PrivateRoute><LessonPlayer /></PrivateRoute>} />
      <Route path="/courses/:courseId/learn/:lessonId" element={<PrivateRoute><LessonPlayer /></PrivateRoute>} />
    </Routes>
  );
};

export default AppRoutes;
